export default {
  "t-physical-examination": "Examen Físico",
  "t-physical-examination-logs": "Informe de Verificación de Equipo",
  "t-terminal-data-upload-configuration": "Configuración de Carga de Datos de Terminal",
  "t-terminal-strategy-parameters": "Parámetros de Estrategia de Terminal",
  "t-strategy-execution-report": "Informe de Ejecución de Estrategia",
  "t-terminal-data-analysis": "Análisis de Datos de Terminal",
  "t-configuration-parameters": "Parámetros de Configuración",
  "t-data-alert-config": "Configuración de Datos y Alertas",
  "t-data-upload-alert-event-config": "Configuración de Carga de Datos y Eventos de Alerta",
  "t-history": "Historial",
  "t-health-check-date": "Fecha de Verificación de Salud",
  "t-health-score": "Puntuación de Salud",
  "t-check-items": "Elementos de Verificación",
  "t-detection-status": "Estado de Verificación de Hardware",
  "t-device-basic-info": "Información Básica del Dispositivo",
  "t-healthy": "Saludable",
  "t-optimal": "Normal",
  "t-unhealthy": "No Saludable",
  "t-skip": "Omitir",
  "t-printer": "Impresora",
  "t-voltage": "Voltaje",
  "t-temperature": "Temperatura",
  "t-charging-status": "Estado de Carga",
  "t-print-distance": "Distancia de Impresión",
  "t-print-head-size": "Tamaño de Cabezal de Impresión",
  "t-bootloader-version": "Versión de Bootloader",
  "t-internal-software-version": "Versión de Software Interno",
  "t-uptime": "Tiempo de Actividad",
  "t-detection-content": "Se probaron {total} elementos en total, aprobaron {pass} elementos, omitieron {skip} elementos",
  "t-not-charging": "No se está cargando",
  "t-charging": "Cargando",
  "t-closed": "Cerrado",
  "t-opened": "Abierto",
  "t-mobile-data": "Datos Móviles",
  "t-wifi": "WIFI",
  "t-unknown": "Desconocido",
  "t-medical-inspection": "Inspección Médica",
  "t-health-status": "Estado de Salud",
  "t-manual": "Manual",
  "t-automatic": "Automático",
  "t-manual-physical-examination-type": "Manual",
  "t-automatic-physical-examination-type": "Automático",
  "t-device-data-acquisition": "Adquisición de Datos del Dispositivo",
  "t-device-data-stop-collection": "Detener la Adquisición de Datos del Dispositivo",
  "t-device-health-check": "Verificación de Salud del Dispositivo",
  "t-auto-health-check": "Verificación Automática de Salud",
  "t-tha-logs": "Registros de Verificación de Salud THA",
  "t-battery-brand": "Marca",
  "t-charging-duration": "Duración de Carga",
  "t-charging-current": "Corriente de Carga",
  "t-charge-cycles": "Ciclos de Carga",
  "t-charge-cycle-count": "Número de Ciclos de Carga",
  "t-low-temperature-warning-count": "Recuento de Advertencias de Baja Temperatura",
  "t-high-temperature-warning-count": "Recuento de Advertencias de Alta Temperatura",
  "t-data-upload": "Lista de Carga de Datos",
  "t-alert-event": "Evento de Alerta",
  "t-device-config": "Configuración de Dispositivo THA",
  "t-config-sync-log": "Registro de Sincronización de Configuración",
  "t-event-trigger-time": "Hora de Activación del Evento",
  "t-event-upload-time": "Hora de Subida del Evento",
  "t-battery-overheating": "Advertencia de Alta Temperatura de Batería",
  "t-battery-undervoltage": "Advertencia de Baja Temperatura de Batería",
  "t-cpu-overheating": "Apagado por Alta Temperatura de Batería",
  "t-event-battery-high-temperature": "Advertencia de alta temperatura de la batería",
  "t-event-battery-low-temperature": "Advertencia de baja temperatura de la batería",
  "t-event-cpu-high-temperature": "Alta temperatura de la CPU",
  "t-event-battery-high-temperature-shutdown": "Apagado por alta temperatura de la batería",
  "t-event-battery-low-temperature-shutdown": "Apagado por baja temperatura de la batería",
  "t-event-type": "Tipo de Evento",
  "t-total-records": "Registros Totales",
  "t-peripheral": "Periférico",
  "t-module": "Módulo",
  "t-sampling-period": "Período de Muestreo",
  "t-sampling-period-1-minute": "1 minuto",
  "t-sampling-period-3-minutes": "3 minutos",
  "t-sampling-period-5-minutes": "5 minutos",
  "t-sampling-period-10-minutes": "10 minutos",
  "t-sampling-period-30-minutes": "30 minutos",
  "t-sampling-period-60-minutes": "60 minutos",
  "t-upload-interval": "Intervalo de Carga",
  "t-upload-interval-less-than-sampling-period": "El intervalo de carga no puede ser menor que el período de muestreo",
  "t-sample-count": "Recuento de Muestras",
  "t-valid-sample-count": "Recuento de Muestras Válidas",
  "t-upload-timestamp": "Marca de Tiempo de Carga",
  "t-sample-timestamp": "Marca de Tiempo de Muestra",
  "t-config-sync-logs": "Registros de Sincronización de Configuración",
  "t-data-point": "Punto de Datos",
  "t-policy-updated": "Política Ha Sido Actualizada",
  "t-policy-consistent": "Política Está Consistente",

// 应用信息
  "t-app-name": "Nombre de la App",
  "t-package-name": "Nombre del Paquete",
  "t-is-system": "¿Es App del Sistema?",
  "t-app-version": "Versión de la App",
  "t-authorisations": "Autorizaciones",
  "t-installed-at": "Instalado en",
  "t-app-size": "Tamaño",
// 网络流量统计
  "t-uplink-traffic": "Tráfico de Enlace Saliente",
  "t-downlink-traffic": "Tráfico de Enlace Entrante",
  "t-traffic-total": "Tráfico Total",
  "t-monitor-more": "más",
// 网络连接状态
  "t-router-name": "Nombre del Enrutador",
// 外设使用统计
  "t-swipe-card-count": "Recuento de Tarjetas Deslizadas",
  "t-insert-card-count": "Recuento de Tarjetas Insertadas",
  "t-tap-card-count": "Recuento de Tarjetas Tocadas",
  "t-card-fail-count": "Recuento de Fallos de Tarjeta",
  "t-print-mileage": "Distancia de Impresión",
  "t-print-speed": "Velocidad de Impresión",
  "t-print-grayscale": "Escala de Grises de Impresión",

  "t-open-tha-model-waiting": "La solicitud THA ha sido iniciada, por favor espere ..",
  "t-manually-initiated-health-check-failed": "No se pudo iniciar manualmente la verificación de salud",
  "t-health-check-initialization-failed": "Error al inicializar la verificación de salud",
  "t-manually-initiated-health-check-success": "La verificación de salud se inició correctamente, consulte el informe de verificación de salud",
  "t-monitor-abnormal": "Abnormal",
  "t-monitor-start-date": "Start Date",
  "t-monitor-end-date": "End Date",
  "t-monitor-battery-status": "Battery Status",
  "t-monitor-current-capacity": "Nivel de batería",
  "t-monitor-key-focus": "Key Focus",
  "t-monitor-battery-trend": "Battery Trend",
  "t-monitor-temperature-battery-threshold": "Temperature Threshold / Battery Threshold",
  "t-monitor-system-resource-trend": "System Resource Trend",
  "t-monitor-storage-high": "High Storage Usage",
  "t-monitor-network-traffic-trend": "Network & Traffic Trend",
  "t-monitor-link-stable": "Stable Link",
  "t-monitor-data-summary": "Data Summary",
  "t-monitor-metric": "Metric",
  "t-monitor-current-value": "Current",
  "t-monitor-minimum-value": "Minimum",
  "t-monitor-maximum-value": "Maximum",
  "t-monitor-average-value": "Average",
  "t-threshold": "Threshold",
  "t-monitor-unit-times": "times",
  "t-monitor-unit-meter": "m",
  "t-monitor-no-sampling-time": "No sampling time",
  "t-monitor-device-info": "Device Info",
  "t-monitor-software-version": "Software Version",
  "t-monitor-sma-version": "SMA Version",
  "t-monitor-pos-service": "POS Service",
  "t-monitor-network-connection": "Network Connection",
  "t-monitor-ip-address": "IP Address",
  "t-monitor-mac-address": "MAC Address",
  "t-monitor-battery-info": "Battery Info",
  "t-monitor-battery-brand": "Battery Brand",
  "t-monitor-collection-summary": "Collection Summary",
  "t-monitor-valid-rate": "Valid Rate",
  "t-monitor-battery-level": "Battery",
  "t-monitor-current": "Current",
  "t-monitor-over-threshold": "Over Threshold",
  "t-monitor-below-threshold": "Below Threshold",
  "t-monitor-idle": "Idle",
  "t-monitor-charge-cycle-stats": "Charge Cycle Statistics",
  "t-monitor-high": "High",
  "t-monitor-charge-count": "Charge Count",
  "t-monitor-cumulative": "Cumulative",
  "t-monitor-current-cycle": "Current Cycle",
  "t-monitor-high-temperature-warning": "High Temp Warning",
  "t-monitor-severe": "Severe",
  "t-monitor-controllable": "Controllable",
  "t-monitor-low-temperature-warning": "Low Temp Warning",
  "t-monitor-system-resource": "System Resource",
  "t-monitor-network-signal": "Network Signal",
  "t-monitor-weak": "Weak",
  "t-monitor-good": "Good",
  "t-monitor-stable": "Stable",
  "t-monitor-application-traffic": "Application Traffic",
  "t-monitor-current-sample": "Current Sample",
  "t-monitor-peripheral-stats": "Peripheral Stats",
  "t-monitor-need-attention": "Needs Attention",
  "t-monitor-usage": "Usage",
  "t-monitor-ethernet": "Ethernet",
  "t-monitor-link-normal": "Link Normal",
  "t-monitor-fetch-failed": "Failed to fetch monitor data",
  "t-version-change-timeline": "Línea de tiempo de cambios de versión de software",
  "t-version-change-count": "{count} cambios de versión",
  "t-version-timeline-empty": "Sin registros de cambios de versión",
  "t-version-timeline-multiple-events": "Varios eventos",
  "t-version-timeline-event": "Evento",
  "t-version-timeline-init": "Inicialización",
  "t-version-timeline-update": "Actualización de versión",
  "t-version-timeline-upgrade": "Actualización",
  "t-version-timeline-rollback": "Reversión",
  "t-version-timeline-exception": "Excepción",
  "t-version-timeline-current": "Actual",
  "t-data-upload-data": "Resumen de Datos THA",
  "t-tha-data-overview": "Resumen de Datos THA",
  "t-manual-physical-examination-and-automatic-physical-examination": "Durante el examen físico manual, el dispositivo debe instalar POS Manager, esta aplicación se utiliza para detectar el dísplay, el touchscreen, la cámara, el altavoz, los botones, la huella dactilar, el micrófono, el lector de tarjetas magnéticas, el lector de tarjetas a chip, el lector de tarjetas sin contacto, la impresora, el indicador de estado, el buzzador y el módulo de almacenamiento seguro de pagos. También incluye elementos de inspección física automática: número de serie del dispositivo, hora de inspección, estado de Bluetooth, carga actual del CPU, memoria RAM en uso actual, memoria de almacenamiento en uso actual, tiempo de encendido, ubicación, estado de carga, temperatura de la batería, voltaje de la batería, capacidad de la batería, tipo de comunicación, tipo de señal, dirección del router, velocidad de transmisión, dirección MAC de WiFi, intensidad de la señal, interruptor de red y distancia de impresión",
  "t-manual-physical-examination-and-automatic-physical-examination-auto": "Durante la inspección física automática, el dispositivo no requiere instalar POS Manager, esta aplicación se utiliza para detectar el número de serie del dispositivo, la hora de inspección, el estado de Bluetooth, la carga actual del CPU, la memoria RAM en uso actual, la memoria de almacenamiento en uso actual, el tiempo de encendido, la ubicación, el estado de carga, la temperatura de la batería, el voltaje de la batería, la capacidad de la batería, el tipo de comunicación, el tipo de señal, la dirección del router, la velocidad de transmisión, la dirección MAC de WiFi, la intensidad de la señal, el interruptor de red y la distancia de impresión",
  "t-power-level": "Nivel de Energía",
}
